import { render } from "./ViewReports.vue?vue&type=template&id=dd99bf3c&scoped=true"
import script from "./ViewReports.vue?vue&type=script&lang=js"
export * from "./ViewReports.vue?vue&type=script&lang=js"

import "./ViewReports.vue?vue&type=style&index=0&id=dd99bf3c&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dd99bf3c"]])

export default __exports__